'use strict'

// Global variables
window.firstSetupG2 = true;

window.ReportSharedFunctions = {
    ShowUnknownWordsFoundMessageIfThereAreAny: function (amountOfWordsToReviewForUser) {
        if (amountOfWordsToReviewForUser && amountOfWordsToReviewForUser > 0) {
            $('.unknownWordsFoundMessage').html(window.Resources.UnknownWordsToReview + " (" + amountOfWordsToReviewForUser + ")")
        } else {
            console.info('No unknown words found to review for user');
            $('.unknownWordsFoundMessage').html("")
        }
    },
    GetPreviousReportRequest: function (reportID) {
        const req = $.ajax({
            type: 'GET',
            data: {
                Report_UID: reportID,
            },
            url: '/legacy/Reports/GetReportContentByReportID',
            dataType: 'json'
        });

        return req;
    },
    RemoveOrderProcedureFromLock: function(orderProcedureUID) {
        return $.ajax({
            async: false,
            type: 'POST',
            url: '/legacy/Locks/ReleaseLockByTypeAndRecordID',
            data: {
                LockType: LockType.Report,
                RecordID: orderProcedureUID
            }
        });
    },
    OnReloadRemoveAddedProceduresInReport: function() {
        const procedureContainer = document.getElementById("procInReport");
        if (procedureContainer) {
            const procedureElements = procedureContainer.querySelectorAll('[id^="fromOtherInOrder"]');

            procedureElements.forEach(procedureElement => {
                const numberSpan = procedureElement.querySelector('span.hidden.number');
                if (numberSpan) {
                    const procedureId = numberSpan.textContent || numberSpan.innerText;
                    this.RemoveOrderProcedureFromLock(procedureId);
                }
            });
        }
    },
    ShowPreviousReportPopup: function(reportID, titlePopup, viewbagUniquePrefix, isScreening, isTranscription) {
        let content = "";
        let reportInfo = "";
        $('#previousScreening').empty();
        $('#previousScreening').hide();
        $('#divPopupPreviousReport' + viewbagUniquePrefix + ' p#previousReportContent').show();
        $('#divPopupPreviousReport' + viewbagUniquePrefix).parent().removeClass('isScreeningPopup');

        if (reportID != "") {
            const setReportDictatedOrValidatedValues = (dictated, validated, hasSupervisor) => {
                if (dictated) {
                    $('#previousReportInfoDictated').html(data.DictatedBy);
                    $('#previousReportInfoDictatedTime').html(data.DictatedDateTime);
                    $('#previousReportInfoDictated').parent().removeClass('backGreen');
                    $('#previousReportInfoDictated').parent().addClass('backGreen');
                }
                else {
                    $('#previousReportInfoDictated').html($("<div/>").html(window.Resources.None).text());
                    $('#previousReportInfoDictatedTime').html("&nbsp;");
                    $('#previousReportInfoDictated').parent().addClass('backRed');
                    $('#previousReportInfoDictated').parent().removeClass('backGreen');
                }
                if (validated) {
                    $('#previousReportInfoValidated').html(data.ValidatedBy);
                    $('#previousReportInfoValidatedTime').html(data.ValidatedDateTime);
                    $('#previousReportInfoValidated').parent().addClass('backGreen');
                    $('#previousReportInfoValidated').parent().removeClass('backRed');
                }
                else {
                    $('#previousReportInfoValidated').html($("<div/>").html(window.Resources.None).text());
                    $('#previousReportInfoValidatedTime').html("&nbsp;");
                    $('#previousReportInfoValidated').parent().addClass('backRed');
                    $('#previousReportInfoValidated').parent().removeClass('backGreen');
                }
                if (hasSupervisor) {
                    $('#previousReportInfoSupervisorHolder').show();
                    $('#previousReportInfoSupervisor').html(data.SupervisorName);
                }
                else {
                    $('#previousReportInfoSupervisorHolder').hide();
                    $('#previousReportInfoSupervisor').html("&nbsp;");
                }
            }

            const setPreviousReport = (data) => {
                if (data.AllOk !== true) return;

                if (data.NotFound === true) {
                    if (!isTranscription){
                        $('.btnCopyPreviousReport').hide();
                        $('.btnCopyPreviousReportToG2').hide();
                        $('#openPreviousReportUID').val("0");
                        $('#openPreviousReportOrderUID').val("0");
                        $('input#openPreviousReport').hide();
                    }

                    content = '<span class="reportPopupInfo">' + htmlDecode(data.Content) + '</span>';
                    $('#previousReportInfo').hide();
                    $('#divPopupPreviousReport' + viewbagUniquePrefix + ' .dicVal').hide();
                }
                else {
                    if (!isTranscription) {
                        if (data.Screening === true || isScreening === true) {
                            $('.btnCopyPreviousReport').hide();
                            $('.btnCopyPreviousReportToG2').hide();
                        } else {
                            $('.btnCopyPreviousReport').show();
                            $('.btnCopyPreviousReportToG2').show();
                        }
                    }

                    setReportDictatedOrValidatedValues(data.Dictated, data.Validated, data.HasSupervisor);

                    try {
                        $('#divPopupPreviousReport' + viewbagUniquePrefix + ' span.datetime').each(function (i, y) {
                            const unformattedModDate = $(this).html();
                            const m = moment(unformattedModDate, "MM/DD/YYYY hh:mm:ss A");
                            if (m.isValid()) {
                                $(this).html(m.calendar());
                            }
                        });
                    }
                    catch {}

                    if (data.Screening === true) {
                        content = "";
                        $('#divPopupPreviousReport' + viewbagUniquePrefix).parent().addClass('isScreeningPopup');
                        $('#previousScreening').html(data.Content);
                        $('#previousScreening').show();
                        $('#divPopupPreviousReport' + viewbagUniquePrefix + ' p#previousReportContent').hide();
                    }
                    else {
                        content = htmlDecode(data.Content);
                    }
                    $('#previousReportInfo').show();
                    $('#divPopupPreviousReport' + viewbagUniquePrefix + ' .dicVal').show();

                    if (!isTranscription) {
                        $('#openPreviousReportUID').val(reportID);
                        $('#openPreviousReportOrderUID').val(data.Order_UID);
                        $('input#openPreviousReport').show();
                    }
                }
            }

            const reqPrvRep = ReportSharedFunctions.GetPreviousReportRequest(reportID).done(function() {
                setPreviousReport(reqPrvRep.responseJSON);
                $('#divPopupPreviousReport' + viewbagUniquePrefix + ' p#previousReportContent').html(content);

                $('#divPopupPreviousReport' + viewbagUniquePrefix + ' p#previousReportInfo').html(reportInfo);
                $("#divPopupPreviousReport" + viewbagUniquePrefix).dialog("option", "title", titlePopup);
                $("#divPopupPreviousReport" + viewbagUniquePrefix).dialog("option", "position", { my: "right top", at: "right-25 top+125", of: '#contentView' });

                $('#divPopupPreviousReport' + viewbagUniquePrefix).dialog('open');

                if (!isTranscription){
                    //<!-- begin copy functionality -->
                    $('#hiddenPreviousContent').val(content);
                    //<!-- end copy functionality -->
                }
            });
        }
        else {
            if (!isTranscription){
                $('.btnCopyPreviousReport').hide();
                $('.btnCopyPreviousReportToG2').hide();
                $('#openPreviousReportUID').val("0");
                $('#openPreviousReportOrderUID').val("0");
                $('input#openPreviousReport').hide();

                //<!-- begin copy functionality -->
                $('#hiddenPreviousContent').val(content);
                //<!-- end copy functionality -->
            }

            content = '<span class="reportPopupInfo">' + window.Resources.InfoReportNotAvailable + '</span>';
            $('#previousReportInfo').hide();

            $('#divPopupPreviousReport' + viewbagUniquePrefix + ' .dicVal').hide();
            $('#divPopupPreviousReport' + viewbagUniquePrefix + ' p#previousReportContent').html(content);

            $('#divPopupPreviousReport' + viewbagUniquePrefix + ' p#previousReportInfo').html(reportInfo);
            $("#divPopupPreviousReport" + viewbagUniquePrefix).dialog("option", "title", titlePopup);
            $("#divPopupPreviousReport" + viewbagUniquePrefix).dialog("option", "position", { my: "right top", at: "right-25 top+125", of: '#contentView' });
            $('#divPopupPreviousReport' + viewbagUniquePrefix).dialog('open');
        }
    },
    LaunchPacsIntegrationFor(accessionNumbers, multiple = null, compare = null) {
        const params = new URLSearchParams({
            multiple: multiple,
            compare: compare,
        });
        accessionNumbers.forEach(accessionNumber => params.append('numbers', accessionNumber));
        return fetch('/legacy/Json/LaunchPACSIntegration?' +
            params, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                "X-Requested-With": "XMLHttpRequest"
            }
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if (data.Done) {
                console.log(`Image(s) opened in PACS`);
            } else if (data.Message) {
                console.error(`Failed to open image(s) in PACS: ${data.Message}`);
            } else {
                console.error(`Failed to open image(s) in PACS, check WCF client logs`);
            }
            return data;
        });
    },
    SendORUOnClose(forOrderProcedureIDs)
    {
        fetch('/api/exports/sendoruonreportclose',
            {
                    body: JSON.stringify(forOrderProcedureIDs),
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    method: 'POST',
                    credentials: 'include'
            })
            .catch(e => console.error('Error sending ORU after report close:', e));
    },
    LaunchEmptyPacsIntegration(forceClear) {
        if (!window.userHasPACSIntegration)
        return true;

        $.ajax({
            type: "POST",
            timeout: 10000,
            data: { forceClear: forceClear },
            url: '/legacy/Json/LaunchEmptyPACSIntegration'
        });
    },
    GetTextBlockContentCall(textblockID) {
        const orderProcedureList = document.getElementById('procInReport');
        const procList = document.getElementById('proceduresInReporContainer');
        const procH2Overlap= document.getElementById('proceduresH2Overlap');
        const orderProcedureIDs = Array.from((orderProcedureList ?? procList ?? procH2Overlap).querySelectorAll('.hidden.number')).map(x => x.innerText * 1);
        
        const urlParams = new URLSearchParams({
            ID: textblockID,
            Order_UID: Model.OrderID,
        });
        orderProcedureIDs.forEach(x => urlParams.append('OrderProcedureIDs', x));
        
        return fetch('/legacy/System/GetTextBlockContent?' + urlParams, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then((response) => {
                return response.json();
            });
    },
    GetTextBlockContent(id, textToReplace) {
        ReportSharedFunctions.GetTextBlockContentCall(id).then((data) => {
            if (data.AllOk) {
                $('#divautocomplete').hide();
                $('#divautocomplete .emptyRemarks').hide();
                $('ul.listFound').remove();
                let content = tinymce.activeEditor.getContent();
                content = content.replace(textToReplace, data.Content);
                content = content.replace(/&lt;RSDK.*?Anchor&gt;/g, "");
                tinymce.activeEditor.setContent(content);
            } else if (data.Message) {
                console.error(`Failed getting texblock content: ${data.Message}`);
            } else {
                console.error(`Failed getting texblock content. General error`);
            }
            return data;
        });
    },
    GetTextFromSpeechDocument: function() {
        return new Promise((resolve, reject) => {
            if (userHasSpeechRecognition && useG2Speech) {
                clearTimeout(window.pollG2Timeout);
                $('#btnValidateAndCloseFile').attr('disabled', true);
                $('#btnSaveAndCloseFile').attr('disabled', true);

                closeActiveSpeech().done(function (e) {
                    $('#btnValidateAndCloseFile').removeAttr('disabled');
                    $('#btnSaveAndCloseFile').removeAttr('disabled');

                    $.ajax({
                        type: "GET",
                        url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                        async: true,
                        data: {
                            GUID: reportGUID,
                            submit: false,
                            Order_UID: Model.OrderID
                        },
                        timeout: 15000,
                        success: function (data) {
                            clearTimeout(window.pollG2Timeout);
                            if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                                if (data.ReportGUID) {
                                    reportGUID = data.ReportGUID;
                                }
                                $('#startSpeechRecognition').removeClass('disabled');
                                tinymce.activeEditor.setContent(data.Result);
                            } else if (data.ErrorG2) {
                                $('#startSpeechRecognition').removeClass('disabled');
                                alert(data.ErrorMessage);
                                reject(new Error(data.ErrorMessage));
                                return;
                            } else if (data.Error) {
                                console.log('Error getting G2speechdocumentOnSaveAndClose');
                                $('#startSpeechRecognition').removeClass('disabled');
                            }
                            resolve();
                        },
                        error: function(error) {
                            reject(error);
                        }
                    });
                }).fail(function (e) {
                    $('#btnValidateAndCloseFile').removeAttr('disabled');
                    $('#btnSaveAndCloseFile').removeAttr('disabled');
                    reject(e);
                });
            } else {
                resolve();
            }
        });
    },
    InitReportPage() {
        window.firstSetupG2 = true;
        window.alreadyAddedTemplateToG2 = false;
        window.pollG2Timeout;
    },
    // Setup TinyMCE for a report page with the expected html. This also sets up the searching and interacting with TextBlocks to insert while typing in the editor
    InitTextEditor(model, disableTextBlockSearch) {
        let textToRemove = ""; // Used to replace TEXT_xxx with the selected textblock content...

        // Firstly, we need to remove the previously existing report (in case we switched pages).
        // This ensures we can properly reinitialize the editor.
        // This first part is only necessary when switching between files using the FilingCabinet (without full page reload)
        if (tinymce.get('divOrderReport'))
            tinymce.remove();

        // This removes the orphaned TinyMCE instance from the saved HTML in the FilingCabinet (only really needs to happen after page reload)
        const toxEl = document.querySelector('div.tox.tox-tinymce');
        if (toxEl) {
            toxEl.remove();
            document.querySelector('#divOrderReport').style.display = ''; // Reset the styling of the linked textarea so that TinyMCE does not start hidden after reload
        }

         const getContent = () => {
            // In case we do a reload, fill in the content in the ReportContent
            const previousContent = $('textarea#ReportContent').attr('value');
            if (previousContent && previousContent !== '')
                return tinymce.activeEditor.setContent(previousContent);

            // If existing report in DB, passed with model, load its content
            if(model.ReportContent !== "") {
                model.ReportContent = model.ReportContent
                    ?.replace(/<strong>(.*?)<\/strong>/gm, "<b>$1</b>")
                    .replace(/<em>(.*?)<\/em>/gm, "<i>$1</i>");

                return tinymce.activeEditor.setContent(model.ReportContent);
            }

            let content = model.DefaultReportTemplate;

             // AutoInsert TextBlocks functionality
             if (model.ReportContent === '') { // Check ReportContent for existing reports, or check if there was already something changed from the default
                 if (model.AutoInsertTextBlock) {
                     content += model.AutoInsertTextBlock.Content;

                     tinymce.activeEditor.setContent(content);
                     $('textarea#ReportContent').val(content);
                     $('textarea#ReportContent').attr('value', content);
                     tinyMCE.activeEditor.focus();
                 }
                 else if (model.MultipleAutoInsertOptions) {
                     window.loadAutoInsertTextBlocks(model.MultipleAutoInsertOptions, function onClick(row){
                         // Wacky "removal" of Dialog
                         document.getElementById('textBlockOptions').innerHTML = '';

                         content += row.Content;

                         tinymce.activeEditor.setContent(content);
                         $('textarea#ReportContent').val(content);
                         $('textarea#ReportContent').attr('value', content);
                         tinyMCE.activeEditor.focus();

                         model.AutoInsertTextBlock = { Name: row.Name };
                         if(startSpeechRecognition && !screening && $('#editableContent').val() === 'false')
                         {
                             launchG2Speech();
                         }
                     }, function onCancel() {
                         document.getElementById('textBlockOptions').innerHTML = '';

                         if(startSpeechRecognition && !screening && $('#editableContent').val() === 'false')
                         {
                             launchG2Speech();
                         }
                     });
                 }
                 else {
                     tinymce.activeEditor.setContent(content);
                     $('textarea#ReportContent').val(content);
                     $('textarea#ReportContent').attr('value', content);
                     tinyMCE.activeEditor.focus();
                 }
             }

        }

        const keyUpEvent = (e) => {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('textarea#ReportContent').attr('value', tinymce.activeEditor.getContent());
        }

        const keyDownEvent = (e) => {
            if ($('#editableContent').val() === "false") {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                $('#divEditAndDeleteSpeechDocument').dialog('open');
                return false;
            }

            // Enter
            if ($('ul.listFound').length > 0 && (e.keyCode === 13 || e.which === 13)) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                $('ul.listFound li.focussed').trigger('click');
                return false;
            }

            // Tab
            if ($('ul.listFound').length > 0 && (e.keyCode === 9 || e.which === 9)) {
                e.preventDefault();
                const focussed = $('ul.listFound li.focussed');
                if (focussed.next().length > 0) {
                    focussed.removeClass('focussed');
                    focussed.next().addClass('focussed');
                }
                else {
                    focussed.removeClass('focussed');
                    $('ul.listFound li').first().addClass('focussed');
                }
                return false;
            }
        }

        const headerStyles = [];
        const setupHeaderstyle = () => {
            fetch('/api/user/details')
                .then(res => res.json())
                .then(res => {
                    if (res.HeaderBold) headerStyles.push('bold');
                    if (res.HeaderUnderline) headerStyles.push('underline');
                    if (res.HeaderItalic) headerStyles.push('italic');
                    if (res.HeaderUppercase) headerStyles.push('uppercase');
                })
                .catch(e => console.error('Error fetching user details for Header Styles:', e));
        }

        // Setup tinymce instance
        tinymce.init({
            content_css: "/tinymce/skins/content/default/content.css",
            skin: false,
            baseUrl: '',
            selector: 'div#divOrderReport',
            browser_spellcheck: true,
            height: 500,
            plugins: 'lists',
            menubar: false,
            elementpath: false,
            entity_encoding: 'raw',
            toolbar: 'bold italic underline | headerstyle casechange textblocks | doseinformation clinicalinformation diagnosticquestion proceduredescription procedurecode',
            extended_valid_elements: 'b,i,strong,em',
            valid_elements: '*[*]',
            content_style: '.interim { color: lightgray; }',
            force_br_newlines: true,
            forced_root_block : 'div',
            formats: {
                bold : {inline : 'b' },
                italic : {inline : 'i' },
                underline : {inline : 'u'}
            },
            setup: editor => {
                // Events
                editor.on('init', getContent);
                // Make sure we're not formatting the automatically selected trailing space on double-clicking a word
                editor.on('BeforeExecCommand', function (e) {
                    if (e.command !== 'mceToggleFormat') {
                        return;
                    }
                    
                    const rng = editor.selection.getRng();
                    const text = editor.selection.getContent({ format: 'text' });

                    if (text.endsWith(' ')) {
                        rng.setEnd(rng.endContainer, rng.endOffset - 1);
                        editor.selection.setRng(rng);
                    }
                });
                // Let the the escape keyup event bubble and indicate as handled for tinymce
                editor.on('keyup', (event) => { if (event.key === "Escape") { 
                    event.stopImmediatePropagation();
                    const clone = new KeyboardEvent(event.type, event);
                    window.dispatchEvent(clone);
                 }  }); 
                // Tab navigation
                editor.on('keydown', function(e) {
                    // Check if the autocompleter menu is open
                    const autocompleterMenu = document.querySelector('.tox-autocompleter');

                    if (!autocompleterMenu || e.keyCode !== 9) {
                        return;
                    }

                    if (!(autocompleterMenu && e.keyCode === 9))
                        return;

                    e.preventDefault();
                    e.stopPropagation();

                    // Get all items in the autocompleter menu
                    const items = autocompleterMenu.querySelectorAll('.tox-collection__item');

                    // Find the currently selected item
                    const selectedItem = autocompleterMenu.querySelector('.tox-collection__item--active');

                    if (!items.length)
                        return;

                    let nextIndex = 0;

                    if (selectedItem) {
                        const itemsArray = Array.from(items);
                        const currentIndex = itemsArray.indexOf(selectedItem);
                        nextIndex = (currentIndex + 1) % items.length;
                    }

                    items.forEach(item => item.classList.remove('tox-collection__item--active'));

                    items[nextIndex].classList.add('tox-collection__item--active');

                    return false;

                }, true);
                editor.on('change', e => {
                     // IMPORTANT This is VERY important to keep!
                     // When we remove the previous TinyMCE instance (when moving from report to report) we actually delete the previous instance
                     // because it is still kept on a "global" level (search tinymce.remove() in this file). Because of that remove we trigger one final 'change' event
                     // which sets the textarea#ReportContent to whatever the last value it had in memory (being the content of the previous report)
                     // By checking if the is_removing flag is set to true we can block the event from doing this, and thus prevent this issue.
                    if (e.originalEvent && e.originalEvent.is_removing)
                        return;

                    $('textarea#ReportContent').attr('value', e.target.getContent());
                }); // Event when clicking the toolbar buttons
                editor.on('keyup', keyUpEvent);
                editor.on('keydown', keyDownEvent);
                editor.on('SetContent', e => {
                    if(e.content === '<div><br data-mce-bogus="1"></div>')
                        return;
                    $('textarea#ReportContent').attr('value', e.target.getContent())
                });

                // Custom buttons
                editor.ui.registry.addButton('casechange', {
                    icon: 'change-case',
                    tooltip: window.Resources.Uppercase,
                    onAction: () => {
                        const bookmark = editor.selection.getBookmark();
                        editor.selection.setContent(editor.selection.getContent().toUpperCase());
                        editor.selection.moveToBookmark(bookmark);
                    }
                });
                const getTextBlockContent = (autocompleteApi, rng, value) => {
                    if(value === '0')
                        return;

                    ReportSharedFunctions.GetTextBlockContentCall(value).then((data) => {
                        if (data.AllOk) {
                            editor.selection.setRng(rng);
                            editor.insertContent(data.Content);
                            autocompleteApi.hide();
                        } else if (data.Message) {
                            console.error(`Failed getting texblock content: ${data.Message}`);
                        }
                        else
                        {
                            console.error(`Failed getting texblock content`);
                        }
                    });
                };

                const registerTextBlockAutocompleter = (editor, triggerId, triggerText) => {
                    if(disableTextBlockSearch)
                        return;
                    editor.ui.registry.addAutocompleter(triggerId, {
                        trigger: triggerText,
                        minChars: 1,
                        columns: 1,
                        onAction: getTextBlockContent,
                        fetch: (pattern) => {
                            const dictatedByID = $('#dictatedByID').length ? $('#dictatedByID').val() : 0;
                            const orderProcedureList = document.getElementById('procInReport');
                            const procList = document.getElementById('proceduresInReporContainer');
                            const procH2Overlap = document.getElementById('proceduresH2Overlap');
                            const procedureIDs = Array.from((orderProcedureList ?? procList ?? procH2Overlap).querySelectorAll('.hidden.number')).map(x => x.innerText * 1);

                            const params = new URLSearchParams();
                            params.append('SearchTerm', pattern);
                            params.append('DictatedBy_UID', dictatedByID);

                            if (procedureIDs && procedureIDs.length) {
                                procedureIDs.forEach(id => {
                                    params.append('OrderProcedureIDs', id);
                                });
                            }

                            return new Promise((resolve) => {
                                fetch(`/legacy/System/GetTextBlockByNameForReport?${params.toString()}`, {
                                    method: 'GET',
                                    headers: {
                                        'Accept': 'application/json'
                                    }
                                })
                                    .then(response => response.json())
                                    .then(function (data) {
                                        if (data.AllOk) {
                                            if (data.List.length > 0) {
                                                const results = data.List.map(item => ({
                                                    type: 'autocompleteitem',
                                                    value: String(item.ID),
                                                    text: item.Name,
                                                }));
                                                resolve(results);
                                            }
                                            else {
                                                resolve([{
                                                    type: 'autocompleteitem',
                                                    value: '0',
                                                    text: window.Resources.NoTextBlocksFound,
                                                    icon: 'warning'
                                                }]);
                                            }
                                        } else {
                                            console.error("Error getting text blocks");
                                            resolve([]);
                                        }
                                    });
                            });
                        }
                    });
                };

                registerTextBlockAutocompleter(editor, 'textblocks_lower', 'text_');
                registerTextBlockAutocompleter(editor, 'textblocks_upper', 'TEXT_');

                setupHeaderstyle();
                editor.ui.registry.addButton('headerstyle', {
                    icon: 'typography',
                    tooltip: window.Resources.HeaderStyle,
                    onAction: () => {
                        const bookmark = editor.selection.getBookmark();
                        headerStyles.forEach(s => {
                            if (s === 'uppercase')
                                editor.selection.setContent(editor.selection.getContent().toUpperCase());
                            else
                                editor.formatter.apply(s);
                        });
                        editor.selection.moveToBookmark(bookmark);
                    }
                });

                if (!disableTextBlockSearch) {
                    editor.ui.registry.addButton('textblocks', {
                        icon: 'format',
                        tooltip: window.Resources.TextBlocks,
                        onAction: () => {
                            const dialog = $('#divShowTextBlocksForRadiologist');
                            dialog.dialog('open');
                            window.loadReportTextBlocks();
                        }
                    });
                }

                editor.ui.registry.addIcon('procedurecode', '<img style="width: 18px; height: 18px" src="/icons/icnCode.png" alt="@Global.ProcedureCode" />');
                editor.ui.registry.addButton('procedurecode', {
                    icon: 'procedurecode',
                    tooltip: window.Resources.AddProcedureCodesTooltip,
                    onAction: () => {
                        tinymce.activeEditor.execCommand('mceInsertContent', false, Model.ProceduresInOrderReport.InReport.map(x => x.Code).join('<br>'));
                    }
                });

                editor.ui.registry.addIcon('doseinformation', '<img style="width: 18px; height: 18px" src="\/icons\/icnRadioactiveBlack.png" alt="@Global.DoseInformation" />');
                editor.ui.registry.addButton('doseinformation', {
                    icon: 'doseinformation',
                    tooltip: window.Resources.AddDoseInformationTooltip,
                    onAction: () => {
                        tinymce.activeEditor.execCommand('mceInsertContent', false, Model.ProceduresInOrderReport.InReport.map(x => `${x.Code} ${x.DoseInformation || '-'}`).join('<br>'));
                    }
                });

                editor.ui.registry.addButton('clinicalinformation', {
                    icon: 'info',
                    tooltip: window.Resources.AddClinicalInformationTooltip,
                    onAction: () => {
                        if (Model.ClinicalInfo) {
                            tinymce.activeEditor.execCommand('mceInsertContent', false, Model.ClinicalInfo);
                        }
                    }
                });

                editor.ui.registry.addButton('diagnosticquestion', {
                    icon: 'help',
                    tooltip: window.Resources.AddDiagnosticQuestionTooltip,
                    onAction: () => {
                        if (Model.OrderDiagnosticQuestion) {
                            tinymce.activeEditor.execCommand('mceInsertContent', false, Model.OrderDiagnosticQuestion);
                        }
                    }
                });

                editor.ui.registry.addButton('proceduredescription', {
                    icon: 'document-properties',
                    tooltip: window.Resources.AddProcedureDescriptionsTooltip,
                    onAction: () => {
                        tinymce.activeEditor.execCommand('mceInsertContent', false, Model.ProceduresInOrderReport.InReport.map(x => x.Description).join('<br>'));
                    }
                });
            },
            paste_preprocess: (editor, args) => {
                // Might be a bit overkill but cleaning up pasted text to be left with clean elements only
                args.content = args.content.replace(/(class=.*?)([ >])/g, ' $2');
                args.content = args.content.replace(/style='[^']*?'/g, '');
                args.content = args.content.replace(/lang=.*? /g, ' ');
                args.content = args.content.replace(/\n/g, '');
            }
        });

        if (!disableTextBlockSearch) {
            $('body').on('click', 'ul.listFound li', function (e) {
                e.stopPropagation();
                e.stopImmediatePropagation();
                const id = $(this).find('.foundTextblockID').val();
                const textToReplace = $(this).find('.textToReplace').val();

                if(!id) {
                    console.warn('textBlockID is null, bailing early...');
                    return;
                }
                if(!textToReplace) {
                    console.warn('textToReplace is null, bailing early...');
                    return;
                }

                $(this).prop("disabled", true);
                ReportSharedFunctions.GetTextBlockContent(id, textToReplace);
            });
        }
    },
    setContentAtCursor(textBlock) {
        const dialog = $('#divShowTextBlocksForRadiologist');
        dialog.dialog('close');
        
        if (tinymce && tinymce.activeEditor) {
            tinymce.activeEditor.execCommand('mceInsertContent', false, textBlock);
            tinymce.activeEditor.focus();
        }
    }
};

window.ReplaceProcedure = function (item) {
    const toReplace = $('input[name=EditableProcedure]:checked').val();
    const replaceWith = item.id;

    let procs = [];

    $('tr.nomenGroup').each(function (i, obj) {
        const toRep = $(obj).find('input[name=EditableProcedure]').val();
        const toRepProc = $(obj).find('input[name=ProcedureID]').val();
        let repWProc;
        if (toRep == toReplace) {
            repWProc = replaceWith;
        }
        else {
            repWProc = toRepProc;
        }
        procs.push([toRep, toRepProc, repWProc]);
    });


    if (toReplace) {
        GetToVerifyNomenclatures(toReplace, replaceWith, procs, false);
    }
};

window.GetToVerifyNomenclatures = function (toReplace, replaceWith, procs, first) {
    $.ajax({
        url: "/legacy/Reports/ShowUpdatedNomenclatures",
        type: "POST",
        dataType: "json",
        traditional: true,
        async: true,
        data: {
            Order_UID: Model.OrderID,
            ProcedureReplacements: JSON.stringify(procs),
            First: first
        },
        complete: function (data) {
            $('div#partialVerifyNomenclatures').html(data.responseText);
        }
    });
};

window.performEOLFunctionality = function(){
    if (EOLSaveOrValidate == 'None') {
        //Do nothing
    }
    else if (EOLSaveOrValidate == 'Save') {
        $('#btnSaveAndCloseFile').trigger('click', [true]);
    }
    else if (EOLSaveOrValidate == 'Validate') {
        $('#btnValidateAndCloseFile').trigger('click', [true]);
    }
    else if (EOLSaveOrValidate == 'Transcribe') {
        $('#btnSendToTranscription').trigger('click', [true]);
    }
    else if (EOLSaveOrValidate == 'Preliminary') {
        $('#btnSendToPreliminary').trigger('click', [true]);
    }
};

window.launchSpeechXHR = undefined;
window.launchG2Speech = function () {

    const AddPollG2Timeout = () => {
        if (window.pollG2Timeout)
            window.clearInterval(window.pollG2Timeout);
        window.pollG2Timeout = setInterval(function (e) {
            launchG2Speech()
        }, 2000);

        timeouts.push(pollG2Timeout);
    }

    if (window.pollG2Timeout)
        window.clearInterval(window.pollG2Timeout);

    let firstSetupG2 = !window.g2SpeechAlreadyOpened;
    let timeout = 15000;
    if (firstSetupG2) {
        timeout = 60000;
    }
    let reportContent = null;
    if ((Model.ReportContent === null || Model.ReportContent === "") && !Model.Dictated && !window.alreadyAddedTemplateToG2) {
        window.alreadyAddedTemplateToG2 = true;
        if (Model.DefaultReportTemplate !== null && Model.DefaultReportTemplate !== "") {
            reportContent = Model.DefaultReportTemplate;
        } else {
            reportContent = $('textarea#ReportContent').attr('value');
        }
    }
    try {
        launchSpeechXHR = $.ajax({
            type: 'GET',
            async: false,
            data: {
                FirstSetup: firstSetupG2,
                Order_UID: Model.OrderID,
                GUID: reportGUID,
                ReportContent: reportContent,
                TextBlockName: firstSetupG2 ? Model.AutoInsertTextBlock?.Name : null
            },
            timeout: timeout,
            url: '/legacy/Reports/LaunchG2SpeechOnClient',
            success: function (data) {
                if (data.Error) {
                    $('#startSpeechRecognition').removeClass('disabled');
                    clearTimeout(window.pollG2Timeout);
                    launchSpeechXHR?.abort();
                }
                else if(data.Suspended)
                {
                    window.g2SpeechAlreadyOpened = false;

                    AddPollG2Timeout();
                }
                else if (firstSetupG2) {
                    window.g2SpeechAlreadyOpened = true;
                    AddPollG2Timeout();
                    $('#startSpeechRecognition').addClass('disabled');
                }
                else if (data.AllOk && !data.Closed) {
                    if (data.GUID) {
                        reportGUID = data.GUID;
                    }
                    $('#startSpeechRecognition').removeClass('disabled');
                    tinymce.activeEditor.setContent(data.Text);
                    clearTimeout(window.pollG2Timeout);
                    launchSpeechXHR?.abort();

                    closeActiveSpeech();
                    performEOLFunctionality();
                }
                else if (data.Closed) {
                    $('#startSpeechRecognition').removeClass('disabled');
                    clearTimeout(window.pollG2Timeout);
                    launchSpeechXHR?.abort();
                    window.g2SpeechAlreadyOpened = false;
                    window.alreadyAddedTemplateToG2 = false;
                }
                else
                {
                    AddPollG2Timeout();
                }
            },
            error: function (data) {
                $('#startSpeechRecognition').removeClass('disabled');
                clearTimeout(window.pollG2Timeout);
                launchSpeechXHR?.abort();

            }
        });
    } catch {
        $('#startSpeechRecognition').removeClass('disabled');
        launchSpeechXHR?.abort();
        console.error('Error starting up G2Speech:', err);
    }
};

window.closeActiveSpeech = function(fileName) {
    const req = $.ajax({
        type: "POST",
        url: "/legacy/Reports/CloseActiveSpeech",
        timeout: 20000,
        async: true,
        data: {
            fileName: fileName
        },
        success: () => {
            speechAlreadyClosed = true;
            window.g2SpeechAlreadyOpened = false;
            window.alreadyAddedTemplateToG2 = false;
        }
    });

    return req;
};


window.closeActiveSpeechAsPromise = async (fileName) => {
    return new Promise((resolve, reject) => {
        window.closeActiveSpeech(fileName)
            .done(() => {
                $('#startSpeechRecognition').removeClass('disabled');
                resolve();
            })
    });
}
